import * as request from '@/utils/request'

export default {
    // 获取公司列表
    getCompanyRequiredList(data) {
      return request.get('/paas/esign/bank/card/required/config/index',data)
    },
    // 添加公司
    postAddRequiredCard(data){
        return request.post('/paas/esign/bank/card/required/config/create',data)
    },
    // 编辑公司
    editRequiredCard(id,data){
        return request.put(`/paas/esign/bank/card/required/config/update/${id}`,data)
    },
    // 删除公司
    deleteRequiredCard(id){
        return request.Delete(`/paas/esign/bank/card/required/config/delete/${id}`)
    }
}